import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import '../CSS/Home.css';
import HomeReportsGrid from '../Components/HomeReportGrid.js'
import Upcoming from '../Components/UpcommingReportGrid.js'
import Mapimage from '../Images/map.png';
import { Link } from 'react-router-dom';
import HomeHighlights from '../Components/HomeHighlights.js';
import Banner from '../Components/Banner.js';
import useIsMobile from '../Components/UseIsMobile.js';


const Home = () => {  

  const [access_token, setAccessToken] = useState('');
  const isMobile = useIsMobile(); // Check if user is on mobile
  const [showRecentReports, setShowRecentReports] = useState(!isMobile);
  const [showFeaturedInsights, setShowFeaturedInsights] = useState(!isMobile);
    
  useEffect(() => {
      // Fetch reports data from your server
      fetch('/api/hello')
          .then((response) => response.json())
          .then((data) => {
              setAccessToken(data.accessToken);
              
          })
          .catch((error) => {
              console.error('Error fetching reports data:', error);
          });
  }, []);

  return (
    <div>
      <Banner />
      <div className="background-image">
        
      <style>
        {`
            iframe {
                border: none;
            }
        `}
        </style>
          
        {access_token && (
            <PowerBIEmbed
                embedConfig={{
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                    id: '1a7fd4bc-959b-4fe5-b2e8-36d6b56150b1',
                    embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=1a7fd4bc-959b-4fe5-b2e8-36d6b56150b1&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
                    accessToken: access_token,
                    tokenType: models.TokenType.Aad, // Use models.TokenType.Aad for SaaS embed
                    pageName : 'ReportSectioncab55760c0176304e7ba',
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false,
                            }
                        },
                        //layoutType: isMobile 
                          //? models.LayoutType.MobilePortrait  // ✅ Mobile Version
                          //: models.LayoutType.Single,
                        navContentPaneEnabled: false, // This hides the entire page selector
                        background: models.BackgroundType.Transparent,
                        
                    }
                }}

                eventHandlers={
                    new Map([
                        ['loaded', function () { console.log('Report loaded'); }],
                        ['rendered', function () { console.log('Report rendered'); }],
                        ['error', function (event) { console.log(event.detail); }],
                        ['visualClicked', () => console.log('visual clicked')],
                        ['pageChanged', (event) => console.log(event)],
                    ])
                }

                cssClassName={"reportClassHome"}

                getEmbeddedComponent={(embeddedReport) => {
                    window.report = embeddedReport;
                }}
            />
            )}
      
      </div>

      {/* Desktop View: Side-by-Side Layout */}
      {!isMobile && (
        <div className="columns">
          <div className="column">
            <h2>Recent Reports</h2>
            <HomeReportsGrid />
          </div>

          <div className="column">
            <h2>Featured Insights</h2>
            <HomeHighlights />
          </div>
        </div>
      )}

      {/* Mobile View: Collapsible Sections */}
      {isMobile && (
        <div className="columns">
          {/* Recent Reports Section */}
          <div className="column">
            <h2 
              className="collapsible-title" 
              onClick={() => setShowRecentReports(!showRecentReports)}
            >
              Recent Reports {showRecentReports ? "▼" : "▶"}
            </h2>
            <div className={`collapsible-content ${showRecentReports ? "open" : ""}`}>
              <HomeReportsGrid />
            </div>
          </div>

          {/* Featured Insights Section */}
          <div className="column">
            <h2 
              className="collapsible-title" 
              onClick={() => setShowFeaturedInsights(!showFeaturedInsights)}
            >
              Featured Insights {showFeaturedInsights ? "▼" : "▶"}
            </h2>
            <div className={`collapsible-content ${showFeaturedInsights ? "open" : ""}`}>
              <HomeHighlights />
            </div>
          </div>
        </div>
      )}
      </div>
  );
};

export default Home;


